import { render, staticRenderFns } from "./AdminEditPod.vue?vue&type=template&id=96d0a584&"
import script from "./AdminEditPod.vue?vue&type=script&lang=js&"
export * from "./AdminEditPod.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditPod.vue?vue&type=style&index=0&id=96d0a584&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports